import { useMemo } from 'react';
import { useGetCampaignFiltersQuery } from '@api/apiCompat';

export const useCampaignFilters = (id: string, skip?: boolean) => {
  const { data, isLoading, error } = useGetCampaignFiltersQuery(
    { campaignTypeId: Number(id) || 0 } as any,
    {
      refetchOnMountOrArgChange: true,
      skip: skip || id === null || id === 'undefined',
    },
  );
  const info = useMemo(() => data ?? [], [data]);
  return { data: info, isLoading, error };
};
